import React, { useEffect } from 'react';
import { X, AlertCircle, CheckCircle, Info, TrendingUp, TrendingDown, Target, Award, AlertTriangle } from 'lucide-react';

const AlertToast = ({ alert, onClose, onMarkRead }) => {
  // Auto-fechar após 8 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 8000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getAlertConfig = (type) => {
    const configs = {
      consecutive_losses: {
        icon: <TrendingDown className="w-5 h-5" />,
        bgColor: 'bg-gradient-to-r from-red-500 to-red-600',
        iconBg: 'bg-red-600/20',
        iconColor: 'text-red-100'
      },
      bank_drop: {
        icon: <AlertCircle className="w-5 h-5" />,
        bgColor: 'bg-gradient-to-r from-orange-500 to-orange-600',
        iconBg: 'bg-orange-600/20',
        iconColor: 'text-orange-100'
      },
      winning_streak: {
        icon: <TrendingUp className="w-5 h-5" />,
        bgColor: 'bg-gradient-to-r from-green-500 to-green-600',
        iconBg: 'bg-green-600/20',
        iconColor: 'text-green-100'
      },
      bank_growth: {
        icon: <Award className="w-5 h-5" />,
        bgColor: 'bg-gradient-to-r from-blue-500 to-blue-600',
        iconBg: 'bg-blue-600/20',
        iconColor: 'text-blue-100'
      },
      goal_reached: {
        icon: <Target className="w-5 h-5" />,
        bgColor: 'bg-gradient-to-r from-purple-500 to-purple-600',
        iconBg: 'bg-purple-600/20',
        iconColor: 'text-purple-100'
      },
      high_stake: {
        icon: <AlertTriangle className="w-5 h-5" />,
        bgColor: 'bg-gradient-to-r from-yellow-500 to-yellow-600',
        iconBg: 'bg-yellow-600/20',
        iconColor: 'text-yellow-100'
      },
      default: {
        icon: <Info className="w-5 h-5" />,
        bgColor: 'bg-gradient-to-r from-gray-600 to-gray-700',
        iconBg: 'bg-gray-600/20',
        iconColor: 'text-gray-100'
      }
    };

    return configs[type] || configs.default;
  };

  const config = getAlertConfig(alert.alert_type);

  const handleMarkRead = () => {
    onMarkRead(alert.id);
    onClose();
  };

  return (
    <div 
      className={`${config.bgColor} rounded-xl shadow-2xl overflow-hidden transform transition-all duration-300 hover:scale-105 max-w-sm w-full`}
      style={{
        animation: 'slideInRight 0.3s ease-out'
      }}
    >
      <div className="p-4">
        <div className="flex items-start gap-3">
          {/* Icon */}
          <div className={`${config.iconBg} ${config.iconColor} p-2 rounded-lg flex-shrink-0`}>
            {config.icon}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-bold text-white mb-1 line-clamp-1">
              {alert.title}
            </h4>
            <p className="text-xs text-white/90 leading-relaxed line-clamp-2">
              {alert.message}
            </p>
            
            {/* Action */}
            {!alert.is_read && (
              <button
                onClick={handleMarkRead}
                className="mt-2 text-xs font-medium text-white/80 hover:text-white underline transition-colors"
              >
                Marcar como lido
              </button>
            )}
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="flex-shrink-0 text-white/80 hover:text-white transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="h-1 bg-black/20">
        <div 
          className="h-full bg-white/50"
          style={{
            animation: 'progressBar 8s linear forwards'
          }}
        />
      </div>
    </div>
  );
};

export default AlertToast;
